import { useState } from "react"
import { toast } from 'react-hot-toast';
import Loader from "../Common/Loader";
import SystemModal from "../Common/SystemModal";
import ajaxUser from "../../util/remote/ajaxUser";

const UpdateDisbursementNumber=(props)=>{

    const [loading, setLoading] = useState(false)
    const [password, setPassword] = useState("")
    const [number, setNumber] = useState("")

    const data = {
        account_id: props.accountID,
        secure_string: password,
        phone_number: number     
    };

    const handleUpdate = async(e) =>{
        e.preventDefault()
        if(password.length>0){
            setLoading(true)
            const server_response = await ajaxUser.updateDisbursementNumber(data);
            
            setLoading(false);
            if(server_response.status==="OK"){
                toast.success(server_response.message);
                setPassword("")
                props.g()
            }
            else{
                toast.error(server_response.message); 
            }
        }
        else{
            toast.error("Enter password provided by the administrator!")
        }  
    }
    

    const RenderFooter=(controls)=>{

        if(loading){
            return <Loader/>
        }else{

            return <> 
                <button className="btn-fill-md text-light bg-martini shadow-martini" type="button" onClick={controls.close}>Close</button>
                <button 
                    type="button" 
                    className={`btn-fill-md text-light bg-dodger-blue`} 
                    onClick={handleUpdate}>Save Changes<i class="fas fa-check mg-l-15"></i>
                </button>
            </>
        }
    }

    return(
        <SystemModal
            title="Update Disbursement Number"
            id="model-update-number"
            size="md"
            footer={RenderFooter}
        >
            <div className="row">
            <div className="mb-4 col-12 form-group">
            <label htmlFor="">New Disbursement Number <span style={{color:"red"}}>*</span></label>
             <input onChange={(e)=>setNumber(e.target.value)} placeholder="Enter new disbursement number..." style={{border: "1px solid grey"}} value={number} type="text" className="form-control"/>
            </div>
            <div className="mb-4 col-12 form-group">
            <label htmlFor="">Admin Password <span style={{color:"red"}}>*</span></label>
             <input onChange={(e)=>setPassword(e.target.value)} required placeholder="Enter password provided by the administrator..." style={{border: "1px solid grey"}} value={password} type="password" className="form-control"/>
            </div>
            </div>
       
        </SystemModal>
    )
}

export default UpdateDisbursementNumber
